import React, {useEffect} from 'react';
import { Globals } from '../../../misc/helpers';
import './BinaryQuestion.css';
import GeneralButton from './GeneralButton';

const BinaryQuestion = (obj: any) => {
	const btnStyle = { margin: '0 5%' };
	var correctBtnStyle: any = {...btnStyle };
	var clicked = false;

	if(Globals.showCorrectPath) {
		correctBtnStyle.border = '2px green solid';
	}
	useEffect(() => {
		let panel = document.getElementById('title-text') as HTMLElement;
		if (panel){
			panel.focus();
			//$(panel).hide();
		}
	}, []);

	return (
		<div className={`ui-container modal-disable-select ${obj.parameters.disabled ? 'disabled-container' : ''}`}>
			<div className="ui-inner-container top-panel-background">
				<div className="top-panel">
					
					<div className="container-title">
						<p id="title-text" tabIndex={0}>{obj.parameters.title}</p>
					</div>
					<div className="top-panel-container">
						<GeneralButton
							text={obj.parameters.correctButton.title}
							onClick={() => {
								if(clicked) {
									return;
								}

								clicked = true;

								if(obj.parameters.correctButton.onClick) {
									obj.parameters.correctButton.onClick();
								}
							}}
							color={obj.parameters.correctButton.greyedOut ? 'grey' : ''}
							style={correctBtnStyle}
						/>
						{obj.parameters.incorrectButton ? (<GeneralButton
							text={obj.parameters.incorrectButton.title}
							onClick={() => {
								if(clicked) {
									return;
								}

								clicked = true;

								if(obj.parameters.incorrectButton.onClick) {
									obj.parameters.incorrectButton.onClick();
								}
							}}
							color={obj.parameters.incorrectButton.greyedOut ? 'grey' : ''}
							style={{...btnStyle,  }}
						/>) : (null)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default BinaryQuestion;
